module.exports = __webpack_public_path__ + "media/old_images/stamp-wheelchair-tested-small-4b59a753.svg";